module.exports = __webpack_public_path__ + "static/media/dslr.59731bae.jpg";